import async from "async";

import CableStore from "~/stores/CableStore";

import Logger from "~/lib/Logger";
import LegacyDispatcher from "~/lib/legacyDispatcher";
import { getJson } from "~/lib/http";

// Takes websocket events (which are just event names and urls) - downloads the
// payload at the URL, then triggeres a dispatcher event with the event name and
// the contents of the URL.
//
// We don't send the payload through the cable because by the time it gets to the
// client, it's usually out of date, and our payloads are much bigger than
// Pusher (our previous websocket provider) would allow.

// NOTE: Websocket is generally initialsied by the legacyDispatcher. Please see
// the notes in legacyDispatcher.js about Websocket and its delicate position
// as an intermediary for push events.

class Websocket {
  queue: {
    push: (data: unknown, callback: (result: unknown) => unknown) => unknown;
  };

  constructor() {
    this.queue = async.queue((payload, callback) => {
      Logger.info(`[Ajax] GET ${payload.url}`);

      const url = payload.urlData
        ? `${payload.url}?${new URLSearchParams(payload.urlData).toString()}`
        : payload.url;

      getJson(url)
        .then((result: any) => {
          return callback(result);
        })
        .catch((error) => {
          Logger.error(`[Ajax] Error fetching ${payload.url}:`, error);
          return callback(null, error);
        });
    });

    // Payload for `websocket:event` has: {event,id,url}
    CableStore.on("websocket:event", (payload) => {
      Logger.info("[Buildkite.Websocket] websocket:event:", payload);

      // @ts-expect-error - TS2554 - Expected 6 arguments, but got 2.
      LegacyDispatcher.emit(
        payload.subevent || payload.event,
        Object.assign(
          {
            fetcher: (urlData) => {
              const newPayload = Object.assign({ urlData }, payload);

              return new Promise((fulfill: (result: unknown) => void) =>
                this.queue.push(newPayload, (result) => fulfill(result)),
              );
            },
          },
          payload,
        ),
      );
    });
  }

  onConnect(callback: () => unknown) {
    CableStore.on("online", () => callback());
  }
}

export default new Websocket();
